import Baby01 from "./baby-01";
import Baby02 from "./baby-02";
import Baby03 from "./baby-03";
import Baby04 from "./baby-04";
import BabyBed01 from "./baby-bed-01";
import BabyBed02 from "./baby-bed-02";
import BabyBottle from "./baby-bottle";
import BabyBoyDress from "./baby-boy-dress";
import BabyGirlDress from "./baby-girl-dress";
import Diaper from "./diaper";
import ToyBrick from "./toy-brick";
import ToyTrain from "./toy-train";

export * from "./baby-01";
export * from "./baby-02";
export * from "./baby-03";
export * from "./baby-04";
export * from "./baby-bottle";
export * from "./baby-boy-dress";
export * from "./baby-girl-dress";
export * from "./baby-bed-01";
export * from "./baby-bed-02";
export * from "./toy-brick";
export * from "./toy-train";
export * from "./diaper";

export const Baby = {
  Baby01,
  Baby02,
  Baby03,
  Baby04,
  BabyBottle,
  BabyBoyDress,
  BabyGirlDress,
  BabyBed01,
  BabyBed02,
  ToyBrick,
  ToyTrain,
  Diaper,
};
